import { Stack, Typography } from '@mui/material'
import { Check, Close } from '@mui/icons-material'

interface RequirementsItemProps {
  met: boolean
  label: string
}

const ICON_PROPS = {
  sx: {
    width: 16,
    height: 16,
    alignSelf: 'center',
  },
}

export function RequirementsItem({ met, label }: RequirementsItemProps) {
  return (
    <Stack direction="row" spacing={1}>
      {met ? <Check {...ICON_PROPS} color="success" /> : <Close {...ICON_PROPS} color="error" />}
      <Typography color={met ? 'success.main' : 'error.main'} fontSize="0.75rem">
        {label}
      </Typography>
    </Stack>
  )
}
